import { useTranslation } from 'react-i18next'
import { Input } from 'antd'
import { clsx } from 'clsx'

import { SearchIcon } from '@/components/Icons'

import styles from './Search.module.scss'

interface SearchProps {
  searchTerm: string
  onSearch: (searchValue: string) => void
  [key: string]: unknown
}

export const Search = (props: SearchProps): React.ReactElement => {
  const { searchTerm, onSearch, ...rest } = props
  const { t } = useTranslation()

  const handleSearch = (searchValue: string): void => {
    onSearch(searchValue)
  }

  return (
    <div className={styles.search}>
      <Input.Search
        {...rest}
        allowClear
        className={clsx('custom-search-input', styles.input)}
        defaultValue={searchTerm}
        enterButton={t('buttonTexts.search')}
        placeholder={t('buttonTexts.search')}
        prefix={<SearchIcon className={styles.icon} />}
        size="large"
        onSearch={handleSearch}
      />
    </div>
  )
}
